import { StockAnalysisModal } from 'modules';



export type StockAnalysisActivityProps = {
};

export const StockAnalysisActivity = (props: StockAnalysisActivityProps) => {

  return (
    <StockAnalysisModal.FC />
  );
};
